import React from "react";
import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { RadioButton } from "../../atoms/RadioButton";
import { PaymentMethod } from "../../pages/order_confirmation/hook";
import { useMaintenance } from "../../../hooks/useMaintenance";
import { fadein, PopupModalContainer } from "./PopupModal.styles";

const paymentImage = require("../../../assets/payment_method.png");

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  selectedPaymentMethod: PaymentMethod | null;
  onSelectPaymentMethod: (paymentMethod: PaymentMethod) => void;
};

export const PaymentSelectModal: React.FC<Props> = ({
  isOpen,
  handleClose,
  selectedPaymentMethod,
  onSelectPaymentMethod,
}) => {
  const { isPaymentMaintenance } = useMaintenance();

  if (!isOpen) return null;

  return (
    <PopupModalContainer $isOpen={isOpen}>
      <ModalContainer $isOpen={isOpen}>
        <PaymentMethodTitle>決済方法を選択</PaymentMethodTitle>
        {!isPaymentMaintenance && (
          <RadioButtonContainer>
            <RadioButton
              text={PaymentMethod.AdvancedPayment.valueOf()}
              name="payment"
              image={paymentImage}
              imageWidth={304}
              imageHeight={176}
              onChange={() =>
                onSelectPaymentMethod(PaymentMethod.AdvancedPayment)
              }
              selected={selectedPaymentMethod === PaymentMethod.AdvancedPayment}
            />
          </RadioButtonContainer>
        )}
        <RadioButtonContainer>
          <RadioButton
            text={PaymentMethod.StorePayment.valueOf()}
            name="payment"
            onChange={() => onSelectPaymentMethod(PaymentMethod.StorePayment)}
            selected={selectedPaymentMethod === PaymentMethod.StorePayment}
          />
        </RadioButtonContainer>

        <ButtonContainer>
          <Button btnStyle="primary" text="閉じる" onClick={handleClose} />
        </ButtonContainer>
      </ModalContainer>
    </PopupModalContainer>
  );
};

const ModalContainer = styled.div<{ $isOpen: boolean }>`
  max-width: 640px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80%;
  background-color: white;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transform: ${({ $isOpen }) =>
    $isOpen
      ? "translate(-50%, -50%) scale(1, 1)"
      : "translate(-50%, -50%) scale(0.9, 0.9)"};
  padding: 36px 24px 40px;
  animation: ${fadein} 0.5s forwards;
`;

const PaymentMethodTitle = styled.p`
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 30px;
`;

const RadioButtonContainer = styled.div`
  padding: 0 0 10px;
`;

const ButtonContainer = styled.div`
  margin-top: 20px;
`;
